module.exports = __webpack_public_path__ + "static/media/ongoing_support.a8e7d261.svg";